export default "__VITE_ASSET__CkeVZVOp__"